import React from 'react';

const SendbirdSendMsgIconSvg = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#789B73" />
      <path
        d="M32.3327 15.668L26.4993 32.3346L23.166 24.8346L15.666 21.5013L32.3327 15.668Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3327 15.668L23.166 24.8346"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendbirdSendMsgIconSvg;
